import { render, staticRenderFns } from "./ReturnToFactory.vue?vue&type=template&id=5efcaf9e&scoped=true"
import script from "./ReturnToFactory.vue?vue&type=script&lang=js"
export * from "./ReturnToFactory.vue?vue&type=script&lang=js"
import style0 from "./ReturnToFactory.vue?vue&type=style&index=0&id=5efcaf9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efcaf9e",
  null
  
)

export default component.exports